import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useLocalizedCategory = (category?: string): string | undefined => {
  const { formatMessage, messages } = useIntl();

  return useMemo(() => {
    if (!category || !Object.prototype.hasOwnProperty.call(messages, category)) {
      return undefined;
    }

    return formatMessage({ id: category });
  }, [category, formatMessage, messages]);
};
